import MatchHeight from 'vanilla-js-match-height'

export default function Heights() {
	new MatchHeight('.js-post-heading')

	new MatchHeight('.js-banner-heading')
	new MatchHeight('.js-banner-content')

	new MatchHeight('.js-card-title')
	new MatchHeight('.js-card-content')
	new MatchHeight('.js-card-link')

	new MatchHeight('.js-plan-heading')
	new MatchHeight('.js-plan-content')

	new MatchHeight('.js-testimonial-heading')
	new MatchHeight('.js-testimonial-content')
	new MatchHeight('.js-testimonial-name')

	new MatchHeight('.js-grid-heading')
	new MatchHeight('.js-grid-content')

	new MatchHeight('.js-range-title')
	new MatchHeight('.js-range-description')
	new MatchHeight('.js-range-bullets')

	new MatchHeight('.js-point-title')
	new MatchHeight('.js-point-content')

	new MatchHeight('.js-cover-price')
}
